import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["isValid"];
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { getErrorData, handleErrorData, ERROR_DATA, filterVAutocomplete } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "DepartureWarehouseChangeDialog",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    order: Object
  },
  data: function data() {
    return {
      shown: false,
      options: {
        color: "primary",
        width: 850,
        zIndex: 2000
      },
      form: {
        warehouseId: null,
        isCreateDomesticTransfer: true,
        isImmediateDomesticTransfer: false,
        isValid: false
      },
      gettingAvailableWarehouses: {
        isPending: false,
        cancellationToken: null,
        results: []
      },
      savingChange: {
        isPending: false,
        cancellationToken: null
      },
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.getAvailableWarehouses();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getAvailableWarehouses: function getAvailableWarehouses() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this$gettingAvailabl;
        var data, _this, response, allWarehouses, orderWarehouse;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.gettingAvailableWarehouses.isPending = true;
              data = {
                allowDeleted: true,
                paging: null
              };
              _this = _this3;
              (_this$gettingAvailabl = _this.gettingAvailableWarehouses.cancellationToken) === null || _this$gettingAvailabl === void 0 || _this$gettingAvailabl.cancel();
              _this.gettingAvailableWarehouses.cancellationToken = axios.CancelToken.source();
              _context2.next = 7;
              return request("/v1/warehouses", "post", data, true, "api", null, _this.gettingAvailableWarehouses.cancellationToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load existing warehouses", true);
                handleErrorData(_this, errorData);
                _this.gettingAvailableWarehouses.isPending = false;
                throw e;
              });
            case 7:
              response = _context2.sent;
              allWarehouses = _toConsumableArray(response.data.warehouses);
              orderWarehouse = allWarehouses.find(function (x) {
                return x.id_warehouse == _this3.order.id_warehouse;
              });
              _this3.gettingAvailableWarehouses.results = allWarehouses.filter(function (x) {
                return x.id_warehouse !== orderWarehouse.id_warehouse;
              }).filter(function (x) {
                return !x.deleted;
              }).filter(function (x) {
                return x.address.country.id_country === orderWarehouse.address.country.id_country;
              }).filter(function (x) {
                return x.availableDestinations.some(function (ad) {
                  var _this3$order$delivery;
                  return ad.countryId === _this3.order.delivery_address.country.id_country && (((_this3$order$delivery = _this3.order.delivery_address.state) === null || _this3$order$delivery === void 0 ? void 0 : _this3$order$delivery.id_state) == null || ad.stateId == null || ad.stateId == _this3.order.delivery_address.state.id_state);
                });
              });
              _this3.gettingAvailableWarehouses.isPending = false;
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    save: function save() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this$savingChange$ca;
        var _this4$form, isValid, withoutValid, _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.savingChange.isPending = true;
              _this4$form = _this4.form, isValid = _this4$form.isValid, withoutValid = _objectWithoutProperties(_this4$form, _excluded);
              _this = _this4;
              (_this$savingChange$ca = _this.savingChange.cancellationToken) === null || _this$savingChange$ca === void 0 || _this$savingChange$ca.cancel();
              _this.savingChange.cancellationToken = axios.CancelToken.source();
              _context3.next = 7;
              return request("/v1/orders/".concat(_this4.order.id_order, "/departure-warehouse"), "put", withoutValid, true, "api", null, _this.savingChange.cancellationToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save departure warehouse", true);
                handleErrorData(_this, errorData);
                _this.savingChange.isPending = false;
                throw e;
              });
            case 7:
              _this4.savingChange.isPending = false;
              _this4.close(true);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    open: function open() {
      this.shown = true;
    },
    close: function close(hasBeenChanged) {
      this.shown = false;
      this.$emit("closed", hasBeenChanged);
    },
    filterVAutocomplete: filterVAutocomplete
  }
};